import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const FiltersLayoutLazy = loadable(
    () => import(/* webpackChunkName: "PagesLight" */ './components/FiltersLayout/FiltersLayout')
);
const FiltersPageCommonLazy = loadable(
    () => import(/* webpackChunkName: "PagesLight" */ './pages/common/CommonSuspense')
);
const FiltersPageCategoryLazy = loadable(
    () => import(/* webpackChunkName: "PagesLight" */ './pages/category/CategorySuspense')
);
const FiltersPageCollectionLazy = loadable(
    () => import(/* webpackChunkName: "PagesLight" */ './pages/collection/CollectionSuspense')
);

export const FiltersLayoutAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <FiltersLayoutLazy />
    </DelayedSuspense>
);

export const FiltersPageCommonAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <FiltersPageCommonLazy />
    </DelayedSuspense>
);

export const FiltersPageCategoryAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <FiltersPageCategoryLazy />
    </DelayedSuspense>
);

export const FiltersPageCollectionAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <FiltersPageCollectionLazy />
    </DelayedSuspense>
);
